import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useSelector } from "react-redux";
import LayoutTwo from "../../Components/Layout/LayoutTwo";
import EventDisplay from "./EventDisplay";
import RegisterModal from "./RegisterModal/RegisterModal";
import TeamSelectModal from "./RegisterModal/TeamSelectionModal";

const EventsPage = () => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  return (
    <HelmetProvider>
      <Helmet>
        <title>Events | Stripe Competition</title>
        <meta
          name="description"
          content="Coding, Robotics, and Technology Competition."
        />
      </Helmet>
      <LayoutTwo
        headerContainerClass="container-fluid"
        headerPaddingClass="header-padding"
      >
        <RegisterModal />
        {isLoggedIn && <TeamSelectModal />}

        <EventDisplay />
      </LayoutTwo>
    </HelmetProvider>
  );
};

export default EventsPage;
